module.exports = __webpack_public_path__ + "assets/img/swiper-img3-588b1213.png";